import { createBrowserRouter } from "react-router-dom";

import LoginPage from "@pages/LoginPage";
import HomePage from "@pages/home_page";
import ConsultaProntoSocorro from "@pages/consulta_pronto_socorro";
import ExamesProcedimentosEletivos from "@pages/ExamesProcedimentos/ExamesProcedimentosEletivos";
import ExamesProcedimentosProntoSocorro from "@pages/ExamesProcedimentos/ExamesProcedimentosProntoSocorro";
import ConsultaEletiva from "@pages/ConsultaEletiva";
import ReimpressaoGuia from "@pages/reimpressao_guia";
import GeracaoLoteCobranca from "@pages/geracao_lote_cobranca";
import ProfissionaisExecutantes from "@pages/profissionais_executantes/profissionais_executantes";
import CadastrarEditarProfissional from "@pages/profissionais_executantes/cadastrar-editar-profissional";
import CallbackPage from "@pages/CallbackPage";

const router = createBrowserRouter([
  {
    path: "/atendimento/exames-procedimentos-pronto-socorro",
    element: <ExamesProcedimentosProntoSocorro />,
  },
  {
    path: "/atendimento/exames-procedimentos-eletivos",
    element: <ExamesProcedimentosEletivos />,
  },
  {
    path: "/atendimento/consulta-eletiva",
    element: <ConsultaEletiva />,
  },
  {
    path: "/atendimento/consulta-pronto-socorro",
    element: <ConsultaProntoSocorro />,
  },
  {
    path: "/atendimento",
    element: <HomePage />,
  },
  { path: "/reimpressao-de-guias", element: <ReimpressaoGuia /> },
  {
    path: "/profissionais-executantes",
    element: <ProfissionaisExecutantes />,
  },
  {
    path: "/cadastrar-editar-profissional",
    element: <CadastrarEditarProfissional />,
  },
  { path: "/lote-cobranca", element: <GeracaoLoteCobranca /> },
  { path: "/biometria-callback", element: <CallbackPage /> },
  {
    path: "/callback",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: <HomePage />,
  },
]);

export default router;
